import React from "react";
import clipboard from "clipboardy";
import { MdContentCopy } from "react-icons/md";
const CopyButton = (props) => {
  const copyText = (text) => {
    clipboard.write(text);
    // TODO: show toast for 'copied' message
    props.setcopyState(text);
  };
  return (
    <div className="ml-2 flex items-center justify-around">
      <button onClick={() => copyText(props.text)}>
        <MdContentCopy size="23px" />
      </button>
      {props.copyState === props.text ? (
        <p className="font-content text-xs bg-green-600 px-1 py-0.5 rounded-md ml-20 absolute">
          Copied!
        </p>
      ) : (
        <p></p>
      )}
    </div>
  );
};
export default CopyButton;
